<div class="content">
  <mat-stepper #stepper>
    <mat-step
      [stepControl]="
        leadTaskService.errorListServiceDetailInformation.formGroup
      "
    >
      <ng-template matStepLabel>{{ labelStep1 | translate }}</ng-template>
      <app-detail-information></app-detail-information>
    </mat-step>
    <mat-step
      [stepControl]="leadTaskService.errorListServiceRoomSelection.formGroup"
    >
      <ng-template matStepLabel>{{ labelStep2 | translate }}</ng-template>
      <app-room-selection></app-room-selection>
    </mat-step>
    <mat-step
      [stepControl]="
        leadTaskService.errorListServiceGeneralInformation.formGroup
      "
    >
      <ng-template matStepLabel>{{ labelStep3 | translate }}</ng-template>
      <app-general-information></app-general-information>
    </mat-step>
  </mat-stepper>
</div>
